import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./EditPlans.css";
import { FaTrashAlt } from "react-icons/fa";
import { useTranslation } from "react-i18next";
function Create_pkg() {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();
  const {t}=useTranslation('backend');
  const [planData, setPlanData] = useState({
    plan_name: "",
    plan_name_ar: "",    
    amount: "",
    duration: "",
    status: "active",
    priority: "",
    features: [],          
  });

  const handleAddFeature = () => {
    setPlanData((prevData) => ({
      ...prevData,
      features: [...prevData.features, { text: "", text_ar: "" }],
    }));
  };

  const handleDeleteFeature = (index) => {
    const isConfirmed = window.confirm(t("deleteFeature"));
    if (isConfirmed) {
      const updatedFeatures = planData.features.filter((_, i) => i !== index);
      setPlanData((prevData) => ({
        ...prevData,
        features: updatedFeatures,
      }));
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPlanData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFeatureChange = (index, key, value) => {
    const updatedFeatures = [...planData.features];
    updatedFeatures[index][key] = value;
    setPlanData((prevData) => ({
      ...prevData,
      features: updatedFeatures,
    }));
  };

  const handleSave = async (e) => {
    e.preventDefault();
    console.log("Saving:", planData);

    try {
      const response = await fetch(`${BASE_URL}/api/plans/addplan`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(planData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const result = await response.json();
      alert(result.message);
      navigate("/dashboard/categories");
    } catch (err) {
      console.error("Save error:", err);
      alert("There was an error saving the changes.");
    }
  };

  return (
    <div className="edit-plan-container">
      <h2>{t('create_new')}</h2>
      <form className="edit-plan-form" onSubmit={handleSave}>
        
        {/* Plan Name (English) */}
        <div className="form-group">
          <label htmlFor="plan_name" dir="ltr">Plan Name (English):</label>
          <div className="value-field">
            <input
              type="text"
              name="plan_name"
              value={planData.plan_name}
              onChange={handleChange}
              dir="ltr"
              required
            />
          </div>
        </div>

        {/* Plan Name (Arabic) */}
        <div className="form-group">
          <label htmlFor="plan_name_ar">اسم الخطة (بالعربية):</label>
          <div className="value-field">
            <input
              type="text"
              name="plan_name_ar"
              value={planData.plan_name_ar}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        {/* Amount */}
        <div className="form-group">
          <label htmlFor="amount">{t('amount')} (SAR):</label>
          <div className="value-field">
            <input
              type="number"
              name="amount"
              value={planData.amount}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        {/* Duration */}
        <div className="form-group">
          <label htmlFor="duration">{t('duration')}</label>
          <div className="value-field">
            <input
              type="number"
              name="duration"
              value={planData.duration}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        {/* Status */}
        <div className="form-group">
          <label htmlFor="status">{t('status')}</label>
          <div className="value-field">
            <select
              name="status"
              value={planData.status}
              onChange={handleChange}
              required
            >
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </div>
        </div>

        {/* Priority */}
        <div className="form-group">
          <label htmlFor="priority">{t('priority')}</label>
          <div className="value-field">
            <input
              type="number"
              name="priority"
              value={planData.priority}
              onChange={handleChange}
            />
          </div>
        </div>

        {/* Features Section */}
        <div className="form-group">
          <div style={{ display: "flex", fontSize: "28px" }}>
            <label className="features">{t('features')}</label>
            <label className="add-features" onClick={handleAddFeature}>
              +
            </label>
          </div>

          <div className="features-containers">
            {planData.features.map((feature, index) => (
              <div key={index} className="feature-items">
                <div className="feature-field" style={{ color: "black" }}>
                  <label>{index + 1}</label>

                  {/* English Feature */}
                  <input
                    type="text"
                    placeholder="Feature (English)"
                    value={feature.text}
                    onChange={(e) => handleFeatureChange(index, "text", e.target.value)}
                  />

                  {/* Arabic Feature */}
                  <input
                    type="text"
                    placeholder="الميزة (بالعربية)"
                    value={feature.text_ar}
                    onChange={(e) => handleFeatureChange(index, "text_ar", e.target.value)}
                  />

                  <button
                    type="button"
                    onClick={() => handleDeleteFeature(index)}
                    className="delete-btn dlt"
                  >
                    <FaTrashAlt className="trash-btn" />
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Buttons */}
        <div className="save-back-btn-class">
          <button type="button" className="back-btn" onClick={() => navigate(-1)}>
            {t('back')}
          </button>
          <button type="submit" className="submit-button">
            {t('save')}
          </button>
        </div>
      </form>
    </div>
  );
}

export default Create_pkg;
